<template>
  <div class="project">
    <p class="control">
      <a class="button" style="border: 0; margin-right: 0px" :disabled="!project.report" @click="download_report()">
        <!-- <span :class="{'has-text-danger':project.report}" class="icon"> -->
        <!-- <i class="fa fa-file-pdf"></i> -->
        <!-- </span> -->
        <svg v-if="project.report" viewBox="0 0 100 100" class="image is-32x32 mr-10">
          <use xlink:href="@/assets/icons/helper_sprite.svg#download-fill" />
        </svg>
        <svg v-else viewBox="0 0 100 100" class="image is-32x32 mr-10">
          <use xlink:href="@/assets/icons/helper_sprite.svg#download" />
        </svg>
      </a>
    </p>
    <div>
      <div class="project__field field has-addons">
        <p class="control">
          <a class="button">
            <span
              @click="
                is_ortho = true;
                is_vector = true;
                set_active_layer({ layer: project, opacity, active: true, only: true });
                SET_LAYER_VECTOR({ active: true, layer: project, only: true });
                fly();
                SET_CLUSTER_ACTIVE_LAYER(project);
              "
              class="project__name is-capitalized is-medium-14-500-42"
              :class="{
                'active-project': is_ortho,
                'has-text-info': cluster_active_layer && project.projectUid === cluster_active_layer.projectUid,
              }"
            >
              <span v-tooltip="project.projectName">{{ project.projectName | truncate(20) }} </span>
            </span>
          </a>
        </p>
        <p class="control">
          <a @click="isOpen = !isOpen" class="button">
            <span class="icon">
              <svg viewBox="0 0 100 100" class="image is-24x24 mr-10">
                <use v-if="!isOpen" xlink:href="@/assets/icons/sprite.svg#collapse" />
                <use v-else xlink:href="@/assets/icons/sprite.svg#expand" />
              </svg>
            </span>
          </a>
        </p>
      </div>
      <b-collapse class="card" :open.sync="isOpen">
        <div class="card-content">
          <div class="project__btns" style="margin-top: 12px">
            <div class="">
              <div class="field is-pulled-left" style="white-space: nowrap; font-size: 14px">
                <input
                  @change="
                    set_active_layer({
                      layer: project,
                      opacity,
                      active: is_ortho,
                    })
                  "
                  v-model="is_ortho"
                  :checked="is_ortho"
                  class="is-checkradio is-small is-info"
                  type="checkbox"
                  :id="'map' + project.projectUid"
                />
                <label class="label" :for="'map' + project.projectUid">{{ localization("app-map", "Map") }}</label>
              </div>
            </div>
            <div class="">
              <div class="field is-text-left">
                <input
                  @change="SET_LAYER_VECTOR({ layer: project, active: is_vector })"
                  v-model="is_vector"
                  class="is-checkradio is-small is-info"
                  type="checkbox"
                  :id="'vector' + project.projectUid"
                />
                <label style="margin-left: 0" class="label" :for="'vector' + project.projectUid">{{ localization("app-issues", "Issues") }}</label>
              </div>
            </div>
            <!-- <div class="columns"> -->
            <div class="">
              <div class="field">
                <input
                  @change="SET_LAYER_TABLES({ layer: project, active: is_table })"
                  v-model="is_table"
                  class="is-checkradio is-info is-small"
                  type="checkbox"
                  :id="'tables' + project.projectUid"
                />
                <label style="margin-left: 0" class="label" :for="'tables' + project.projectUid">{{ localization("app-racks", "Racks") }}</label>
              </div>
              <!-- </div> -->
              <!-- <div class="column">
              <span @click="fly()" class="is-size-7 is-pulled-left flyto-btn">
                <i class="fas fa-paper-plane"></i> FLY
              </span>
              </div>-->
            </div>
          </div>
          <input @change="changeOpacity($event)" v-model="opacity" class="slider is-circle" step="1" min="0" max="100" value="100" type="range" />
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState, mapMutations } from "vuex";

  export default {
    props: ["group_index", "index", "project", "is_group_ortho", "is_group_vector", "is_group_table"],
    data() {
      return {
        layer_meta: null,
        isOpen: false,
        opacity: 100,
        is_ortho: false,
        is_vector: false,
        is_table: false,
      };
    },
    created() {
      // setTimeout(() => {
      //   if (this.group_index == 0 && this.index === 0) {
      //     this.is_ortho = true;
      //     this.is_vector = true;
      //     this.SET_LAYER_VECTOR({ active: this.is_vector, layer: this.project });
      //     this.set_active_layer({
      //       layer: this.project,
      //       opacity: this.opacity,
      //       active: this.is_ortho,
      //       style_change: true,
      //     });
      //     this.SET_CLUSTER_ACTIVE_LAYER(this.project);
      //   }
      // }, 3000);
    },
    methods: {
      ...mapMutations(["SET_LAYER_VECTOR", "SET_LAYER_TABLES", "SET_CLUSTER_ACTIVE_LAYER"]),
      ...mapActions(["set_active_layer", "get_report_url"]),
      changeOpacity() {
        this.map.setPaintProperty("MAPLAYER:" + String(this.project.projectUid), "raster-opacity", parseInt(this.opacity, 10) / 100);
      },
      async download_report() {
        if (this.project.report) {
          let results = await this.get_report_url(this.project);
          window.open(results.data, "_blank");
        }
      },
      fly() {
        if (this.active_layers[this.project.projectUid] && this.active_layers[this.project.projectUid].meta.center) {
          if (this.$store.state.fly_active) {
            this.map.flyTo({
              center: this.active_layers[this.project.projectUid].meta.center.slice(0, 2),
              zoom: 17,
              speed: 5,
            });
          }
        }
      },
    },
    computed: {
      ...mapState(["map", "draw", "features", "active_layers", "cluster_active_layer"]),
    },
    watch: {
      draw: {
        handler(val) {
          this.map.on("style.load", () => {
            if (this.is_ortho) {
              // this.set_active_layer({
              //   layer: this.project,
              //   opacity: this.opacity,
              //   active: this.is_ortho,
              //   style_change: true,
              // });
            }
          });
        },
        immediate: true,
      },
      is_group_ortho: {
        immediate: true,
        handler(val) {
          this.is_ortho = val;
          // this.set_active_layer({
          //   layer: this.project,
          //   opacity: this.opacity,
          //   active: this.is_ortho,
          // });
        },
      },
      is_group_vector: function(val) {
        console.log("is_group_vector",val)
        // this.SET_LAYER_VECTOR({ layer: this.project, active: val});
        this.is_vector = val;
      },
      is_group_table: function(val) {
        this.is_table = val;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .flyto-btn {
    cursor: pointer;
    margin-left: 10px;
  }
  .project__btns {
    display: flex;
    justify-content: start;
  }
  .project {
    display: flex;
    width: 100%;
    text-align: center;
    transition: all 0.2s;
    font-weight: 300;
    &__btns {
      margin-bottom: 0;
      .column {
        padding: 0;
      }
    }
    &__field.has-addons {
      margin: 0;

      display: flex;
      justify-content: start;
      padding: 0;
    }

    .card {
      box-shadow: 0 0 0;
    }
    .field .control {
      margin-bottom: 0;
    }
    .field .label {
      font-family: Barlow-medium;
      color: #171e48;
      opacity: 0.7;
      font-size: 14px;
      font-weight: 500;
      padding: 0;
      margin-left: -0.2rem;
      margin-right: 1rem;
      padding-left: 1.4rem;
    }
    label {
      padding: 0;
    }
    .card-content {
      padding: 0 3px;
    }
    &__name {
      &.active_cluster {
        color: blue;
      }
      opacity: 0.8;

      &.active-project {
        opacity: 1;
      }
      // font-size: 15px;
      width: 155px;
      text-align: left;
      overflow: hidden;
    }
    .slider {
      width: 100%;
    }
    .slider::-webkit-slider-thumb {
      -webkit-appearance: none; /* Override default look */
      appearance: none;
      cursor: pointer; /* Cursor on hover */
      width: 18px;
      height: 18px;
      box-shadow: 0 3px 6px 0 rgba(139, 147, 169, 0.5);
      border: solid 2px #8d95aa;
      background-color: #ffffff;
      margin-top: -6px;
    }
  }
</style>
